import { getAmplitudeInstance } from '../amplitudeHelpers';
import VisitationDay from '../enums/VisitationDay';
import VisitationDisplayMode from '../enums/VisitationDisplayMode';
import VisitationHour from '../enums/VisitationHour';
import VisitationMonth from '../enums/VisitationMonth';

type logTrailDetailsVisitationViewedParams = {
  default_day_selected: VisitationDay;
  default_display_mode: VisitationDisplayMode;
  default_hour_selected: VisitationHour;
  default_month_selected: VisitationMonth;
  trail_id: number;
};

/**
 * User scrolls to the the Visitation module on TDP. Fire this event when the module is visible.
 * @param params - Attributes to log with the amplitude event
 * @param params.default_day_selected - The default selected day when users first saw Visitation module or when mode switches to By Day.
 * @param params.default_display_mode - The default display mode when users first saw Visitation module.
 * @param params.default_hour_selected - The default selected hour when users first saw Visitation module or when mode switches to By Day.
 * @param params.default_month_selected - The default selected month when users first saw Visitation module or when mode switches to By Month.
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsVisitationViewed = (
  { default_day_selected, default_display_mode, default_hour_selected, default_month_selected, trail_id }: logTrailDetailsVisitationViewedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details visitation viewed',
    {
      'default day selected': default_day_selected,
      'default display mode': default_display_mode,
      'default hour selected': default_hour_selected,
      'default month selected': default_month_selected,
      'trail id': trail_id
    },
    callback
  );
};

export default logTrailDetailsVisitationViewed;
